document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.nct-section').forEach(initNestedCollectionTabs);
});

function initNestedCollectionTabs(section) {
  var tabs = section.querySelectorAll('.nct-tab');
  var panels = section.querySelectorAll('.nct-panel');
  var animation = section.dataset.animation || 'fade';

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.getAttribute('data-tab-target');

      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      panels.forEach(function (panel) {
        var isTarget = panel.getAttribute('data-tab-panel') === target;
        panel.classList.remove('is-active', 'nct-anim-fade', 'nct-anim-slide-up');
        if (isTarget) {
          panel.hidden = false;
          panel.classList.add('is-active');
          if (animation !== 'none') {
            panel.classList.add('nct-anim-' + animation);
          }
          initCarousel(panel, section);
        } else {
          panel.hidden = true;
        }
      });
    });
  });

  // Keyboard navigation between tabs
  var tabList = section.querySelector('.nct-tabs');
  if (tabList) {
    tabList.addEventListener('keydown', function (e) {
      var tabArray = Array.prototype.slice.call(tabs);
      var currentIndex = tabArray.findIndex(function (t) { return t.classList.contains('is-active'); });
      if (e.key === 'ArrowRight') {
        var next = tabArray[(currentIndex + 1) % tabArray.length];
        next.click();
        next.focus();
      } else if (e.key === 'ArrowLeft') {
        var prev = tabArray[(currentIndex - 1 + tabArray.length) % tabArray.length];
        prev.click();
        prev.focus();
      }
    });
  }

  // Init carousel for whichever panel starts active
  var activePanel = section.querySelector('.nct-panel.is-active');
  if (activePanel) {
    initCarousel(activePanel, section);
  }
}

function initCarousel(panel, section) {
  if (section.dataset.displayStyle !== 'carousel') return;

  var track = panel.querySelector('[data-carousel]');
  if (!track || track.dataset.nctInit === 'true') return;
  track.dataset.nctInit = 'true';

  var wrap = track.closest('.nct-carousel-wrap');
  var prevBtn = wrap ? wrap.querySelector('.nct-arrow-prev') : null;
  var nextBtn = wrap ? wrap.querySelector('.nct-arrow-next') : null;
  var dotsWrap = panel.querySelector('[data-carousel-dots]');
  var cards = track.querySelectorAll('.nct-card');
  var loop = section.dataset.loop === 'true';
  var autoplay = section.dataset.autoplay === 'true';
  var autoplaySpeed = parseInt(section.dataset.autoplaySpeed, 10) || 4000;
  var autoplayTimer;

  function cardWidth() {
    return cards.length ? cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 16) : 0;
  }

  function scrollByCards(direction) {
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    var atStart = track.scrollLeft <= 4;

    if (direction === 1 && atEnd && loop) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }
    if (direction === -1 && atStart && loop) {
      track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      return;
    }
    track.scrollBy({ left: direction * cardWidth(), behavior: 'smooth' });
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCards(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCards(1); });

  // Dots
  if (dotsWrap && cards.length) {
    dotsWrap.innerHTML = '';
    cards.forEach(function (card, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', function () {
        track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });

    track.addEventListener('scroll', function () {
      var closestIndex = 0;
      var closestDistance = Infinity;
      cards.forEach(function (card, i) {
        var distance = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });
      dotsWrap.querySelectorAll('button').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === closestIndex);
      });
    }, { passive: true });
  }

  // Touch / mouse drag (in addition to native touch scroll)
  var isDown = false, startX, scrollLeftStart;
  track.addEventListener('mousedown', function (e) {
    isDown = true;
    startX = e.pageX;
    scrollLeftStart = track.scrollLeft;
  });
  window.addEventListener('mouseup', function () { isDown = false; });
  track.addEventListener('mouseleave', function () { isDown = false; });
  track.addEventListener('mousemove', function (e) {
    if (!isDown) return;
    e.preventDefault();
    var walk = e.pageX - startX;
    track.scrollLeft = scrollLeftStart - walk;
  });

  // Autoplay
  function startAutoplay() {
    if (!autoplay) return;
    stopAutoplay();
    autoplayTimer = setInterval(function () { scrollByCards(1); }, autoplaySpeed);
  }
  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
  }
  if (autoplay) {
    startAutoplay();
    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('mouseleave', startAutoplay);
  }
}